import { gql } from '@apollo/client'

export const FETCH_EHR_AVAILABLE_DATES = gql`
  query ehrAvailableDates(
    $appointmentKind: EhrAppointmentKind
    $providerKind: EhrAppointmentProviderKind
    $timeZone: String
    $appointmentId: ID
    $providerId: ID
    $userState: AddressState
    $switchingCoach: Boolean
    $startDate: String
    $endDate: String
    $cadence: EhrAppointmentRecurrenceCadence
  ) {
    ehrAvailableDates(
      appointmentKind: $appointmentKind
      providerKind: $providerKind
      timeZone: $timeZone
      appointmentId: $appointmentId
      providerId: $providerId
      userState: $userState
      switchingCoach: $switchingCoach
      startDate: $startDate
      endDate: $endDate
      cadence: $cadence
    ) {
      dates
      crossKindRecurrenceDates
    }
  }
`
